<script setup lang="ts">
import type { Size } from '@ui/types/icon'

const props = withDefaults(
  defineProps<{
    icon: any
    size?: Size
  }>(),
  {
    icon: undefined,
    size: 'md'
  }
)

const { icon, size } = toRefs(props)
</script>

<template>
  <component
    :is="icon"
    :class="useTailwindClasses([useSize(size)])"
  />
</template>
